// src/services/discountPOSService.js
import apiClient from "./api/client";
import ENDPOINTS from "./api/endpoints";

/**
 * POS Discount Service
 * Handles discount operations at the POS level (checkout/billing)
 */
const discountPOSService = {
  /**
   * Get suggested discounts based on current order context
   * @param {Object} params - Query parameters
   * @param {string} params.orderType - Order type (dine_in, takeaway, delivery, online)
   * @param {number} params.subtotal - Current cart subtotal
   * @param {number[]} params.itemIds - Menu item IDs in cart
   * @param {number[]} params.categoryIds - Category IDs in cart
   * @param {number} params.customerId - Customer ID (optional)
   */
  getSuggestions: (params) => {
    const queryParams = new URLSearchParams();

    if (params.orderType) queryParams.append('orderType', params.orderType);
    if (params.subtotal) queryParams.append('subtotal', params.subtotal);
    if (params.itemIds?.length) queryParams.append('itemIds', params.itemIds.join(','));
    if (params.categoryIds?.length) queryParams.append('categoryIds', params.categoryIds.join(','));
    if (params.customerId) queryParams.append('customerId', params.customerId);

    const queryString = queryParams.toString();
    const url = queryString
      ? `${ENDPOINTS.DISCOUNT_POS.SUGGESTIONS}?${queryString}`
      : ENDPOINTS.DISCOUNT_POS.SUGGESTIONS;

    return apiClient.get(url);
  },

  /**
   * Validate a discount code against current order context
   * @param {Object} payload - Validation payload
   * @param {string} payload.code - Discount code to validate
   * @param {string} payload.orderType - Order type
   * @param {number} payload.subtotal - Cart subtotal
   * @param {number[]} payload.itemIds - Menu item IDs in cart
   * @param {number[]} payload.categoryIds - Category IDs in cart
   * @param {number} payload.customerId - Customer ID (optional)
   */
  validateCode: (payload) => {
    return apiClient.post(ENDPOINTS.DISCOUNT_POS.VALIDATE, payload);
  },

  /**
   * Get discount details by code
   * @param {string} code - Discount code
   */
  getByCode: (code) => {
    return apiClient.get(ENDPOINTS.DISCOUNT_POS.GET_BY_CODE(code));
  },

  /**
   * Get customer's usage of a specific discount
   * @param {number} discountId - Discount ID
   * @param {number} customerId - Customer ID
   */
  getCustomerUsage: (discountId, customerId) => {
    return apiClient.get(ENDPOINTS.DISCOUNT_POS.CUSTOMER_USAGE(discountId, customerId));
  },
};

export default discountPOSService;
